import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { ApiConstants } from '../../shared';

@Injectable()
export class DiscoveryService {
    constructor(
        private http: Http,
        private apiConstants: ApiConstants) {
    }
    getWikiTitles(date, page) {
        const url = this.apiConstants.CATALOG_API_URL + 'discovery/wiki?for=' + date + '&page=' + page;
        return this.http.get(url)
          .map(res => res.json())
          .toPromise();
    }

    getTorrentTitles() {
        const url = this.apiConstants.CATALOG_API_URL + 'discovery/torrent';
        return this.http.get(url)
          .map(res => res.json())
          .toPromise();
    }
}


// WEBPACK FOOTER //
// ./src/app/catalogue/discovery/discovery.service.ts